import React from "react";
import about from "../../../assets/img/home/aboutban.jpeg"
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
function AboutBanner() {
    return(
      <>
            <Helmet> <title>About | GreenDart Builders</title> </Helmet>

        <div
            className="page-title"
            style={{ backgroundImage: `url(${about})`}}
          >
            {/* <div className="container position-relative">
              <h1  className="sub-banner-header">About Us</h1>
              <nav className="breadcrumbs">
                <ol>
                  <li><Link className="text-white" to={'/'}>Home</Link></li>
                  <li className="current">About Us</li>
                </ol>
              </nav>
            </div> */}
          </div>
      </>

    );
}

export default AboutBanner;